import { CalamityActionModel } from "./calamity-action.model";
import { CalamityNoteModel } from "./calamity-note.model";

export class CalamityActionNoteModel {
    canId  : string ;
    claCalamityId : string= null;
    canCalamityAction : CalamityActionModel= null;
    canCalamityNote : CalamityNoteModel = null;
    canLastModifiedDate : Date= null;
    canCreatedDate : Date= null; 
    canCalamityNoteId : string;
  }